import { filterTableConfig } from '@manager/config/filter-table-config';

export const tasksConfig = {
  itemsPerPageOptions: filterTableConfig.itemsPerPageOptionsSmall,
};
